import { h } from "@stencil/core";
export class BbgDropdown {
  constructor() {
    this.dropdownId = "dropdown-id";
    this.disabled = false;
    this.label = undefined;
    this.isDynamicWidth = undefined;
    this.dropdownAriaLabel = undefined;
    this.optionsList = [{ value: "", option: "" }];
    this.defaultValue = undefined;
  }
  render() {
    const dropdownCssClasses = {
      "a-dropdown": true,
      "a-dropdown--dynamic-width": this.isDynamicWidth,
      "a-dropdown--disabled": this.disabled,
    };
    return (h("div", { class: dropdownCssClasses }, this.optionsList.map(asd => {
      h("p", null, asd.value);
    }), this.label && h("label", { htmlFor: this.dropdownId }, this.label), h("select", { id: this.dropdownId, disabled: this.disabled, "aria-label": this.dropdownAriaLabel, onInput: e => this.optionSelectHandler(e) }, this.optionsList.map(options => (h("option", { selected: options.value === this.defaultValue, value: options.value }, options.option))))));
  }
  optionSelectHandler(event) {
    this.optionSelected.emit(event.target.value);
  }
  static get is() { return "bbg-dropdown"; }
  static get originalStyleUrls() {
    return {
      "$": ["bbg-dropdown.scss"]
    };
  }
  static get styleUrls() {
    return {
      "$": ["bbg-dropdown.css"]
    };
  }
  static get properties() {
    return {
      "dropdownId": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "The dropdown's id"
        },
        "attribute": "dropdown-id",
        "reflect": false,
        "defaultValue": "\"dropdown-id\""
      },
      "disabled": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "Disables the dropdown"
        },
        "attribute": "disabled",
        "reflect": false,
        "defaultValue": "false"
      },
      "label": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": "The label on the top of the dropdown"
        },
        "attribute": "label",
        "reflect": false
      },
      "isDynamicWidth": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": "Use a dynamic width instead of the full width"
        },
        "attribute": "is-dynamic-width",
        "reflect": false
      },
      "dropdownAriaLabel": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "The HTML aria-label attribute"
        },
        "attribute": "dropdown-aria-label",
        "reflect": false
      },
      "optionsList": {
        "type": "unknown",
        "mutable": false,
        "complexType": {
          "original": "{ value: string; option: string }[]",
          "resolved": "{ value: string; option: string; }[]",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "The list of available languages. This was used instead of a slot to avoid rendering issues"
        },
        "defaultValue": "[{ value: \"\", option: \"\" }]"
      },
      "defaultValue": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "The default selected language"
        },
        "attribute": "default-value",
        "reflect": false
      }
    };
  }
  static get events() {
    return [{
        "method": "optionSelected",
        "name": "optionSelected",
        "bubbles": true,
        "cancelable": true,
        "composed": true,
        "docs": {
          "tags": [],
          "text": "This event will be triggered by a selection"
        },
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        }
      }];
  }
}
